import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Icon from 'components/common/Icon/Icon'
import { A } from 'components/common/Link/Link'
import HeadTitle from 'components/common/HeadTitle/HeadTitle'
import Checkbox from 'components/common/FormElements/Checkbox/Checkbox'
import CheckedGrayImage from 'components/common/FormElements/Checkbox/assets/Checked_Disabled.svg'

export const Remove = styled(A).attrs({
  'data-at-quote-product-remove-link': true
})`
  display: block;
  font-size: 12px;
  ${Media.desktop`
    top: 20px;
    margin-top: 7px;
    width: 80px;
  `}
  ${Media.mobile`
    float: right;
    margin-top: 3%;
    width: auto;
  `}
  ${props => props.service && css`
    ${Mixin.responsive('margin-top', '17px', '13px')}
    ${Mixin.responsive('width', '100%', 'auto')}
    
    ${Media.mobile`
      margin-right: 30px;
    `}
  `}
`

export const Mobile = styled.span`
  display: inline-block;
  width: 60px;
  margin-right: 18px;
  vertical-align: middle;
  padding-bottom: 3px;
  ${Mixin.font.GothamBook(12, 400)}
  ${Mixin.mobileOnly()}
  ${props => props.service && css`
    margin: 13px 18px 0 0;
  `}
  ${props => props.kit && css`
    margin: 11px 8px 0 0;
  `}
`

export const Content = styled.p`
  margin: 0 0 10px;
  font-weight: 600;
  line-height: 19px;
  ${props => props.centered && css`
    max-width: 300px;
    margin: 0 auto 10px;
  `}
`

export const Headline = styled(HeadTitle)`
  ${Mixin.responsive('margin', '0 0 10px', '0 0 18px')}
`

export const OtdPricingMessage = styled.div`
  position: relative;
  padding: 20px;
  background: ${Theme.colors.pale_yellow};
  font-weight: bold;

  div {
    padding-left: 30px;
    font-weight: bold;
  }
`
export const StyledInfoIcon = styled(Icon)`
  position: absolute;
  width: 18px;
  margin-right: 10px;
  ${Media.mobile`
    top: 20px;
  `}
`

export const ItemWrapper = styled.div`
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-color: ${Theme.colors.light_grey};
  ${Mixin.responsive('margin-bottom', '30px', '20px')}
  ${props => props.isSavedForLater === false && css`
    background: ${Theme.colors.white};
  `}
  ${props => props.isSavedForLater === true && css`
    background: ${Theme.colors.white};

    @keyframes hide-product-to-the-left {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(-100%);
        opacity: 0;
      }
    }

    animation: hide-product-to-the-left 0.7s ease-in-out;
    animation-fill-mode: forwards;
  `}
`

export const GrayCheckbox = styled(Checkbox)`
  label input:checked + span {
    &::before {
      background: ${Theme.colors.transparent} url(${CheckedGrayImage}) center/contain no-repeat !important;
    }
  }
`
